import { useMemo } from "react";
import { WithRequiredHasuraRoles } from "src/components/Permissions/WithRequiredHasuraRoles";
import { SearchAndFilterTypes } from "src/constants";
import { useRemoteDataQuery } from "src/hooks/useRemoteDataQuery";
import * as GQL from "src/types/graphql";
import { HasuraRole } from "src/types/hasuraRole";
import { GET_RANKS_FOR_FILTERS } from "../../graphql/queries";
import {
  CommonFilterProps,
  FormFilter,
  MultiSelectFilter,
} from "../CommonFilters";

type RankFilterProps = {
  formTemplateId: string;
} & CommonFilterProps;

export const RankFilter = (props: RankFilterProps) => (
  <WithRequiredHasuraRoles
    roles={[HasuraRole.ADMIN, HasuraRole.ORG_ADMIN, HasuraRole.DISTRICT_ADMIN]}
  >
    <RankFilterImpl {...props} />
  </WithRequiredHasuraRoles>
);

const RankFilterImpl = ({ formTemplateId, ...props }: RankFilterProps) => {
  const { remoteData: getRanksRemoteData } = useRemoteDataQuery<
    GQL.GetRanksForFilters,
    GQL.GetRanksForFiltersVariables
  >(GET_RANKS_FOR_FILTERS, {
    skip: !formTemplateId,
    variables: {
      form_template_id: formTemplateId,
    },
  });

  const rankOptions = useMemo(() => {
    if (
      !getRanksRemoteData.hasData() ||
      !getRanksRemoteData.data.form_school_rank.length
    )
      return [];

    const ranks = getRanksRemoteData.data.form_school_rank.map((school) => ({
      label: (school.rank + 1).toString(),
      id: school.rank.toString(),
    }));
    return [{ label: "No rank", id: "norank" }, ...ranks];
  }, [getRanksRemoteData]);

  return (
    <FormFilter label="Rank">
      <MultiSelectFilter
        filterKey={SearchAndFilterTypes.Rank}
        options={rankOptions}
        {...props}
        placeholder="Type a rank"
      />
    </FormFilter>
  );
};
